<template>
    <aside class="menu pt-6 pl-4">
        <p
            v-t="'Explorer.featured_folders'"
            class="is-capitalized has-text-weight-bold has-text-black is-size-6"
        ></p>
        <div v-for="folder in folders" :key="folder._id" class="py-3">
            <label class="checkbox">
                <input v-model="folder.selected" type="checkbox" />
                {{ folder.name }}
            </label>
        </div>
    </aside>
</template>

<script>
export default {
    props: {
        folders: {
            type: Array,
            default() {
                return [];
            },
            required: true,
        },
        activeFolder: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {};
    },
};
</script>

<style></style>
